export const isMarketplaceEnabled = (): boolean => {
  try {
    return localStorage.getItem('slavaUkraini') !== 'false'
  } catch {
    return true
  }
}
